import { createConversationMessageStream, getConversationMessageRuntimeId } from 'utils';

const API_DOMAIN = process.env.NEXT_PUBLIC_API_DOMAIN;

export const createProjectOperatorRunStream = ({
	abortSignal,
	message,
	messageId,
	onChunk,
	onComplete,
	onError,
	rootApi,
	runId,
	store,
}) => {
	const streamMessageId = getConversationMessageRuntimeId(message.id);

	return createConversationMessageStream({
		baseDomain: API_DOMAIN,
		url: `${rootApi}/messages/${messageId}/runs/${runId}/stream`,
		headers: store.computeHeaders({ accept: 'text/event-stream' }),
		abortSignal,
		messageId: streamMessageId,
		onError,
		onChunk: chunk => onChunk?.({ chunk, messageId: streamMessageId }),
		onComplete: async ({ text }) => {
			await onComplete?.({ messageId: streamMessageId, streamMessageId, text });
		},
	});
};
